<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.paymentSummary.show') +' '+ paymentSummary.reference_number"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <button class="btn btn-dark my-2" @click="goBack">
                    <span class="fa fa-caret-left"></span>
                    <span class="fa fa-caret-left"></span>
                </button>

                <div class="d-inline-block float-right">
                    <button class="btn btn-danger" @click="generate('pdf')">
                        <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.pdf')}}
                    </button>
                    <button class="btn btn-primary" @click="generate('word')">
                        <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.word')}}
                    </button>
                </div>

                <hr>

                <div class="row">
                    <div class="col-md-10 mx-auto">
                        <div class="card" style="padding: 100px 40px; font-size: 95%; width: 720px;margin: 0 auto;">

                            <div class="card-body">
                                    <div class="row offset-md-8  col-4">
                                            <p class="mb-0 w-100">{{student.Title}} {{student.FirstName}}
                                                {{student.LastName}}</p>
                                            <p class="mb-0 w-100" v-if="student.CompanyName">{{student.CompanyName}}</p>
                                            <p class="mb-0 w-100">{{student.StreetAddress}}</p>
                                            <p class="mb-0 w-100">{{student.Zip}} {{student.City}}</p>
                                            <p class="mb-0 w-100">{{student.Country}}</p>
                                    </div>

                                <!-- <div class="clearfix"></div> -->
                                
                                <div class="mt-3">
                                    <p>{{$t('form.paymentSummary.zurich')}} {{paymentSummary.summary_date}}</p>
                                </div>

                                <div>
                                    <h3 class="mb-3">{{ paymentSummary.title }}</h3>
                                    <p>{{ paymentSummary.intro_text }}</p>

                                    <table class="table table-borderless mt-4 payment-summary-table" v-if="paymentSummaryItems.length">
                                        <thead>
                                            <tr>
                                                <th class="text-left font-weight-bold">{{$t('form.paymentSummary.amountReceived')}}</th>
                                                <th class="text-left font-weight-bold">{{$t('form.paymentSummary.invoiceNumber')}}</th>
                                                <th class="text-left font-weight-bold">{{$t('form.paymentSummary.dateFeesReceived')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in paymentSummaryItems" :key="index">
                                                <td class="font-weight-bold d-flex align-items-center">
                                                    <span style="min-width: 36px; text-align: left;">
                                                        {{ paymentSummary.currency }}
                                                    </span>
                                                    
                                                    <span style="display: inline-block; min-width: 60px; text-align: right; font-variant-numeric: tabular-nums;">
                                                        {{ item.amount_received | curreny(decimalDigits, decimalPoint, thousandSeparator) }}
                                                    </span>
                                                </td>
                                                <td class="text-left font-weight-bold">
                                                    {{ item.invoice_number }}
                                                </td>
                                                <td class="text-left font-weight-bold">
                                                    {{ item.payment_date | formatDate(dateFormat) }}
                                                </td>
                                            </tr>

                                            <!-- Total row -->
                                            <tr>
                                                <td colspan="3" class="text-left pt-4">
                                                    <span style="padding-top: 5px;">
                                                        <strong>
                                                            {{ paymentSummary.grand_total_label }} 
                                                            {{ paymentSummary.currency }}
                                                            {{ paymentSummary.total_amount }}
                                                        </strong>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <p class="mt-3 mb-0">{{ paymentSummary.closing_text }}</p>
                                </div>

                                <div>
                                    <p class="mt-5 mb-0">{{ paymentSummary.dean_of_admin_finance }}</p>
                                    <p>{{ $t('form.paymentSummary.deanOfAdminFinance') }}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat', 'decimalDigits', 'decimalPoint', 'thousandSeparator'],

        data() {
            return {
                isLoading: false,
                fullPage: true,

                paymentSummaryItems: [],
                student:{},

                paymentSummary: {
                    id: null,
                    reference_number: '',
                    summary_date: null,
                    title: '',
                    grand_total_label: '',
                    intro_text: '',
                    closing_text: '',
                },

                availableFormats: ['pdf', 'word']
            }
        },

        async mounted() {
            this.getPaymentSummary();
        },

        methods: {
            goBack() {
                const origin = this.$route.query.origin;

                if (origin === 'student') {
                    this.$router.push({
                        name: 'StudentEdit',
                        params: { id: this.student.StudentNumber }
                    });
                    return;
                }

                if (origin === 'alumni') {
                    this.$router.push({
                        name: 'AlumniEdit',
                        params: { id: this.student.StudentNumber }
                    });
                    return;
                }

                if (origin === 'payment-summaries') {
                    this.$router.push({
                        name: 'PaymentSummariesIndex'
                    });
                }

                if (origin === 'pending-payment-summaries') {
                    this.$router.push({
                        name: 'PaymentSummariesPendingIndex'
                    });
                }
            },
            getDateWithMonthInEnglish(date){
                var dateFormat = 'DD MMM YYYY';
                var formattedDate = date ? moment(date).format(dateFormat) : moment().format(dateFormat);
                return formattedDate;
            },
            getDateWithMonthAndYear(date){
                var dateFormat = 'MMM YYYY';
                var formattedDate = date ? moment(date).format(dateFormat) : moment().format(dateFormat);
                return formattedDate;
            },

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {type});
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async generate(type = null) {
                if (!this.availableFormats.includes(type)) return;

                let token = await this.createToken('student-payment-summary');
                if (token == '') return;

                window.open(`/payment-summaries/${this.$route.params.id}/${type}?token=${token}`, '_blank');
            },

            getPaymentSummary() {
                this.isLoading = true;

                if (!this.$route.params.id) return;

                axios
                    .get(`/api/payment-summaries/${this.$route.params.id}`)
                    .then(response => {
                        this.isLoading = false;

                        this.paymentSummary = response.data;

                        this.student = response.data.student || {};

                        this.paymentSummaryItems = response.data.payment_summary_items || [];

                        this.totalAmount = response.data.total_amount;

                        this.summaryTitle = response.data.title;
                        this.summaryIntro = response.data.intro_text;
                        this.summaryGrandTotalLabel = response.data.grand_total_label;
                        this.summaryClosing = response.data.closing_text;

                        this.referenceNumber = response.data.reference_number;

                        this.summaryDate = this.getDateWithMonthInEnglish(response.data.summary_date);

                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    });
            }
        },

    }

</script>
<style scoped>

.payment-summary-table th,
.payment-summary-table td {
    padding: 4px 8px;
    border-bottom: none;
}

.payment-summary-table tr:last-child td {
    border-bottom: none;
}

</style>
